import accountForgotten from '@/components/account/account-forgotten/account-forgotten.vue';

export default {
  components: {
    accountForgotten,
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-forgotten-password/page-forgotten-password.js